import { startOfMonth, addDays } from 'date-fns';
import moveFocusHandler from '../../date-picker/calendar/utils/move-focus-handler';
export function getBaseDate(date, daysToMove, isDateEnabled) {
    var startDate = startOfMonth(date);
    if (isDateEnabled(startDate)) {
        return startDate;
    }
    return moveFocusHandler(startDate, isDateEnabled, function (date) { return addDays(date, daysToMove); });
}
//# sourceMappingURL=get-base-date.js.map